// Image URL helper utility for Starnight Holdings
// Handles converting local paths to full URLs for serving images from the backend

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Converts a local image path to a full URL that can be loaded by the browser
 * Handles various path formats:
 * - Full URLs (http/https) - returned as-is
 * - /api/uploads/... paths - prepends BACKEND_URL
 * - /uploads/... paths - converts to /api/uploads/... and prepends BACKEND_URL
 * - Relative paths - prepends BACKEND_URL
 * 
 * @param {string|null|undefined} path - The image path to convert
 * @returns {string|null} The full URL or null if no path provided
 */
export const getImageUrl = (path) => {
  if (!path) return null;
  
  // Already a full URL
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }
  
  // Path from API (starts with /api/uploads/)
  if (path.startsWith('/api/uploads/')) {
    return `${BACKEND_URL}${path}`;
  }
  
  // Path without /api prefix (starts with /uploads/)
  if (path.startsWith('/uploads/')) {
    return `${BACKEND_URL}/api${path}`;
  }
  
  // Any other relative path
  if (path.startsWith('/')) {
    return `${BACKEND_URL}${path}`;
  }
  
  // Assume it's a relative path, add backend URL
  return `${BACKEND_URL}/${path}`;
};

/**
 * Default placeholder image URL for when no image is available
 */
export const PLACEHOLDER_AVATAR = null;
export const PLACEHOLDER_NEWS_IMAGE = null;

/**
 * Handle image load error gracefully
 * Uses React-compatible approach - set state in onError handler instead
 * @deprecated Use React state-based approach instead of DOM manipulation
 * @param {Event} e - The error event
 */
export const handleImageError = (e) => {
  // Prevent infinite error loops
  e.target.onerror = null;
  e.target.style.display = 'none';
  if (e.target.nextSibling) {
    e.target.nextSibling.style.display = 'flex';
  }
};

export default getImageUrl;
